module.exports = __webpack_public_path__ + "static/img/right.3d2b071b.svg";